import { TFunction } from 'i18next'

import { InvoiceBillingStage } from '../enums/invoiceBillingStage'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { ZervantLocale } from '../enums/zervantLocale'

interface GetInvoiceDocumentTitleOptions {
  billingStage?: InvoiceBillingStage
  documentType: InvoiceDocumentType
  language: ZervantLocale
  t: TFunction
}

export const getInvoiceDocumentTitle = ({
  billingStage,
  documentType,
  language,
  t,
}: GetInvoiceDocumentTitleOptions): string => {
  switch (documentType) {
    case InvoiceDocumentType.CreditNote:
      return t('external_invoices.document_title.credit_note', { lng: language })
    case InvoiceDocumentType.DeliveryNote:
      return t('external_invoices.document_title.delivery_note', { lng: language })
    case InvoiceDocumentType.Quote:
      return t('external_invoices.document_title.quote', { lng: language })
    case InvoiceDocumentType.Invoice:
    default:
      if (billingStage === InvoiceBillingStage.Deposit) {
        return t('external_invoices.document_title.deposit_invoice', { lng: language })
      }
      if (billingStage === InvoiceBillingStage.Final) {
        return t('external_invoices.document_title.final_invoice', { lng: language })
      }
      return t('external_invoices.document_title.invoice', { lng: language })
  }
}
